import hasClass from './hasClass';
import addClass from './addClass';
import removeClass from './removeClass';
function toggleClass(element, classString) {
  if (hasClass(element, classString)) {
    removeClass(element, classString);
  } else {
    addClass(element, classString);
  }
}
export default toggleClass;